import BreadCrumbLink from '../../bread-crumb-link';
import style from './document-insights-folder-bread-crumb.module.scss';

import type { BreadCrumbLink as BreadCrumbLinkType } from '../../types';

const MAX_VISIBLE_BREADCRUMB_LINKS = 5;

type Props = {
  links: BreadCrumbLinkType[];
};

export const DocumentFolderBreadCrumb = ({ links = [] }: Props) => {
  const shouldTruncateFolders = links.length >= MAX_VISIBLE_BREADCRUMB_LINKS;

  let linksArray = links.slice(1);

  if (shouldTruncateFolders) {
    const lastThreeLinks = links.slice(-3);

    linksArray = lastThreeLinks;
  }

  const isLastBreadCrumbLink = (index: number) => {
    return index === linksArray.length - 1;
  };

  const workspaceLink = links[0];

  return (
    <div className={style.DocumentFolderBreadCrumb}>
      <BreadCrumbLink
        workspaceIconCustomClass={style.WorkspaceIcon}
        linkCustomClass={style.FolderLinkText}
        isBreadCrumbInFolderCard={false}
        isFolderBreadCrumb
        isLastBreadCrumbLink={false}
        isSearchedFolderBreadcrumb
        key={workspaceLink.id}
        {...workspaceLink}
      />
      {shouldTruncateFolders && (
        <>
          <span>...</span>
          <span>/</span>
        </>
      )}
      {linksArray.map((link, index) => (
        <BreadCrumbLink
          linkCustomClass={style.FolderLinkText}
          isBreadCrumbInFolderCard={false}
          isFolderBreadCrumb
          isLastBreadCrumbLink={isLastBreadCrumbLink(index)}
          isSearchedFolderBreadcrumb
          key={link.id}
          {...link}
        />
      ))}
    </div>
  );
};
